module.exports = __webpack_public_path__ + "img/ic-logo-payoneer.dfce8e92.svg";